import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyUserIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.533 15.1609C16.533 17.9076 12.7663 18.2251 9.93384 18.2251L9.73114 18.2249C7.92651 18.2205 3.33301 18.1066 3.33301 15.1442C3.33301 12.4536 6.9483 12.094 9.75924 12.0805L10.1365 12.0803C11.941 12.0846 16.533 12.1986 16.533 15.1609ZM9.93384 13.3301C6.38301 13.3301 4.58301 13.9401 4.58301 15.1442C4.58301 16.3592 6.38301 16.9751 9.93384 16.9751C13.4838 16.9751 15.283 16.3651 15.283 15.1609C15.283 13.9459 13.4838 13.3301 9.93384 13.3301ZM9.93384 1.66641C12.3738 1.66641 14.358 3.65141 14.358 6.09141C14.358 8.53141 12.3738 10.5156 9.93384 10.5156H9.90717C7.47217 10.5081 5.49967 8.52225 5.50798 6.08891C5.50798 3.65141 7.49301 1.66641 9.93384 1.66641ZM9.93384 2.85641C8.14967 2.85641 6.69799 4.30725 6.69799 6.09141C6.69217 7.86975 8.13301 9.31975 9.90967 9.32641L9.93384 9.92141V9.32641C11.7172 9.32641 13.168 7.87475 13.168 6.09141C13.168 4.30725 11.7172 2.85641 9.93384 2.85641Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default IconlyUserIcon;
